import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import SourcesMenu from './SourcesMenu';
import { VarName, varNameDetails } from '../utils/varNames';
import SensorIcon from '../styles/icons/SensorIcon';
import {
  getActiveMarker,
  getClickedItem,
  getHighlightedItem,
  getSelectedVars,
} from '../state/selectors';
import { setActiveMarker, setClickedItem } from '../state/actions';
import { themeProps } from '../styles/theme';
import { useAppDispatch, useAppSelector } from '../state/store';

function SelectedVarsIconBtn(): JSX.Element {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const selectedVars = useAppSelector(getSelectedVars);
  const activeMarker = useAppSelector(getActiveMarker);
  const clickedItem = useAppSelector(getClickedItem);
  const highlightedItem = useAppSelector(getHighlightedItem);
  const activeItem = highlightedItem.id ? highlightedItem : clickedItem;
  const selectedVarName = activeItem.varName ?? activeMarker;

  const onClickHandler = (varName: VarName) => {
    dispatch(setClickedItem({ id: '' }));
    dispatch(setActiveMarker(varName));
  };

  return (
    <Box sx={{ display: 'flex', overflowX: 'scroll' }}>
      {selectedVars.map((varName) => {
        const SourceIcon = varNameDetails[varName]?.icon ?? SensorIcon;
        return (
          <Box sx={{ margin: '0 5px', alignSelf: 'center' }} key={varName}>
            <Tooltip title={varNameDetails[varName].label}>
              <IconButton
                onClick={() => onClickHandler(varName)}
                style={{
                  background:
                    selectedVarName === varName
                      ? `${themeProps.colors.green}66`
                      : theme.palette.primary.light,
                }}
              >
                <SourceIcon />
              </IconButton>
            </Tooltip>
          </Box>
        );
      })}
      <Box sx={{ margin: '0 5px' }}>
        <SourcesMenu iconOnlyBtn />
      </Box>
    </Box>
  );
}

export default SelectedVarsIconBtn;
